export enum ClientOnboardingDeliverableStep {
  // Depending on the variant of the deliverable modal, these steps will render
  // different content.
  UPLOAD = 'UPLOAD',
  PROCESSING = 'PROCESSING',
  REVIEW = 'REVIEW',
}

export enum ClientOnboardingDeliverableVariant {
  SUMMARIZE_DOCUMENT = 'SUMMARIZE_DOCUMENT',
  CREATE_ENTITY_OVERVIEW = 'CREATE_ENTITY_OVERVIEW',
  CREATE_BALANCE_SHEET = 'CREATE_BALANCE_SHEET',
  BUILD_OUT_HOUSEHOLD = 'BUILD_OUT_HOUSEHOLD',
  CREATE_ANALYSIS = 'CREATE_ANALYSIS',
  GENERATE_ESTATE_SNAPSHOT = 'GENERATE_ESTATE_SNAPSHOT',
}

export interface ClientOnboardingDeliverableConfig {
  title: React.ReactNode;
  description: string;
  illustration: React.ReactNode;
  calloutText?: string;
}

export interface ClientOnboardingDeliverableModalBodyProps {
  onChildPhaseChange?: (phase: ClientOnboardingDeliverableStep) => void;
  onClose: () => void;
  preselectedExistingDocumentIds?: string[];
}
